import { render, staticRenderFns } from "./TransitionFirmRoles.vue?vue&type=template&id=29d53f4a&scoped=true"
import script from "./TransitionFirmRoles.vue?vue&type=script&lang=js"
export * from "./TransitionFirmRoles.vue?vue&type=script&lang=js"
import style0 from "./TransitionFirmRoles.vue?vue&type=style&index=0&id=29d53f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d53f4a",
  null
  
)

export default component.exports